// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { invoiceSummaryCardStyles } from "@conklin/App/Components/Common/InvoiceSummaryCard";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import DollarSign from "@insite/mobius/Icons/DollarSign";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

invoiceSummaryCardStyles.invoiceSummaryCardGridItem = {
    width: 12,
    css: css`
        padding: 0 20px;
        max-width: 500px;
    `,
};

invoiceSummaryCardStyles.container = { gap: 5 };

invoiceSummaryCardStyles.pageTypeLinkGridItem = { width: 12 };

invoiceSummaryCardStyles.invoiceNumberGridItem = { width: 6 };

invoiceSummaryCardStyles.statusGridItem = { width: 6 };

invoiceSummaryCardStyles.webInvoiceNumberGridItem = { width: 6 };

invoiceSummaryCardStyles.totalGridItem = { width: 6 };

invoiceSummaryCardStyles.actionsCells = {
    css: css`
        min-width: 70px;
        max-width: 100px;
    `,
};

invoiceSummaryCardStyles.dataCells = {
    css: css`
        ${TypographyStyle} {
            color: ${color("text.main")};
            font-weight: normal;
            &:hover {
                color: ${color("text.main")};
            }
        }
    `,
};

invoiceSummaryCardStyles.payLink = {
    ...createLinkIconStyles(DollarSign, "small", "left", false, {
        css: css`
            width: 100%;
            &&& {
                ${TypographyStyle} {
                    font-size: 12px;
                    line-height: 15px;
                    display: inline;
                }

                ${xScreen("lte", "md")} {
                    text-align: right;
                }
            }
        `,
    }),
};
